import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
export function SummarySection() {
  return <section className="py-16 px-4 bg-white" data-id="element-314">
      <div className="max-w-3xl mx-auto" data-id="element-315">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#F0FFF0] p-8 md:p-12 rounded-3xl shadow-xl border-2 border-green-200" data-id="element-316">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-317">
            📦 Lo que vas a recibir hoy (resumen)
          </h2>

          <ul className="space-y-4 text-lg md:text-xl font-bold text-gray-800" data-id="element-318">
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-319">
              <span className="text-green-500 text-2xl flex-shrink-0" data-id="element-320">✅</span>
              <span data-id="element-321">MEGA KIT LECTOESCRITURA completo (Kits #41 al #44)</span>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-322">
              <span className="text-green-500 text-2xl flex-shrink-0" data-id="element-323">✅</span>
              <span data-id="element-324">+50 imprimibles (tarjetas, fichas y juegos)</span>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-325">
              <span className="text-green-500 text-2xl flex-shrink-0" data-id="element-326">✅</span>
              <span data-id="element-327">Guía de dislexia + orientación para adultos</span>
            </li>

            <li className="pt-4 pb-2" data-id="element-328">
              <div className="flex items-center gap-2 text-purple-700 font-black text-xl" data-id="element-329">
                <Gift className="w-6 h-6" data-id="element-330" />
                <span data-id="element-331">5 Bonos de Regalo:</span>
              </div>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border-l-4 border-purple-300" data-id="element-332">
              <span className="text-2xl flex-shrink-0" data-id="element-333">🎁</span>
              <span data-id="element-334">Bono #1 — Guía de Juegos Lectores</span>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border-l-4 border-purple-300" data-id="element-335">
              <span className="text-2xl flex-shrink-0" data-id="element-336">🎁</span>
              <span data-id="element-337">Bono #2 — Kit de Ejercicios Imprimibles</span>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border-l-4 border-purple-300" data-id="element-338">
              <span className="text-2xl flex-shrink-0" data-id="element-339">🎁</span>
              <span data-id="element-340">Bono #3 — Biblioteca de Audiocuentos Educativos</span>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border-l-4 border-purple-300" data-id="element-341">
              <span className="text-2xl flex-shrink-0" data-id="element-342">🎁</span>
              <span data-id="element-343">Bono #4 — Pack Silábico Completo</span>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border-l-4 border-purple-300" data-id="element-344">
              <span className="text-2xl flex-shrink-0" data-id="element-345">🎁</span>
              <span data-id="element-346">Bono #5 — Lecturas con Imágenes (Edición Especial)</span>
            </li>

            <li className="pt-4 pb-2" data-id="element-347">
              <div className="flex items-center gap-2 text-yellow-600 font-black text-xl" data-id="element-348">
                <Sparkles className="w-6 h-6" data-id="element-349" />
                <span data-id="element-350">2 Regalos Premium Extra (solo HOY):</span>
              </div>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border-2 border-yellow-300" data-id="element-351">
              <span className="text-2xl flex-shrink-0" data-id="element-352">⭐</span>
              <span data-id="element-353">Pack Premium de 30 Textos Cortos (15 min/día)</span>
            </li>
            <li className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border-2 border-yellow-300" data-id="element-354">
              <span className="text-2xl flex-shrink-0" data-id="element-355">⭐</span>
              <span data-id="element-356">Kit de Lecturas Piramidales (+30 textos progresivos)</span>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}